import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Grid, TextField, MenuItem, Button, Avatar } from "@mui/material";
import { LocalTaxiRounded, ScheduleRounded, ChecklistRtlRounded } from "@mui/icons-material";

// Components
import ChatApp from "../../Header/Bell_icon";

// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";

//Services
import DispatcherApi from "Services/Dispatcher";

const Dispatcherhead = ({setSelectedstatus , setSelectedservice , selectedservice , userType }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [services, setservices] = useState([]);
//console.log('selectedservice from parent --->',selectedservice);
//const reduxState = useSelector((state) => state);
//console.log("Redux State:", reduxState);
    const profiledetails = useSelector(
        (state) => state?.ProfileSettingsReducer?.profiledetails?.image
      );

    const handleSelectedServiceDrivers = (event) => {
        //console.log('selected services --->',event.target.value);
        setSelectedservice(event.target.value); // Update selected value
      };
    
      const getservicesanddrivers = useCallback(() => {
        dispatch(showLoader("Loading please wait..."));
        const onSuccess = (res) => {
          dispatch(hideLoader());
          //console.log("fetched user request data--->",res?.data);
          if (res?.data?.status === true) {
            //console.log("fetched active service data from header--->",res?.data?.data?.serviceTypeDetails)
            setservices(res?.data?.data?.serviceTypeDetails);
          } else {
            setservices([]);
          }
        };
        const onFailure = (err) => {
          dispatch(hideLoader());
          dispatch(
            showSnackbar({
              message: err?.response?.data?.message || "Failed to fetch service and drivers data",
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "error",
            })
          );
          //console.log("Get member / partner details Api", err);
        };
        DispatcherApi.getdriversandservices().then(onSuccess, onFailure);
      }, []);  

    useEffect(() => {
   //  console.log('profiledetails--->',profiledetails);
        getservicesanddrivers();
      }, []);  

    return (
      <>

<Grid container alignItems="center" spacing={2} className={classes.dispatcherheader} >     
      {/* Vehicle Category Selector */}
      <Grid item>
        <TextField
          select
          label="Vehicle Category"
          onChange={handleSelectedServiceDrivers}
          value={selectedservice || ""}
          variant="outlined"
          size="small"
          sx={{ minWidth: 180 }}
        >
          {services?.map((service) => (
            <MenuItem key={service._id} value={service._id}>
              {service.serviceName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

{/* Status Filters */}
<Grid item>
<Button variant="contained"  
sx={{ background: "#30e356", color: "#fff", textTransform: "none" }}
onClick={()=>{setSelectedstatus('ACTIVE')}}
>
    Active
</Button>
<Button variant="contained" 
sx={{ background: "#f44336", color: "#fff", textTransform: "none", marginLeft: 1 }}
onClick={()=>{setSelectedstatus('OFFLINE')}}
>
    Offline
</Button>
<Button variant="contained"  
sx={{ background: "#0472e2", color: "#fff", textTransform: "none", marginLeft: 1 }}
onClick={()=>{setSelectedstatus('RIDING')}}
>
    Riding
</Button>
{/* <Button variant="contained" startIcon={<LocalTaxiRounded />} sx={{ background: "#f4c20d", color: "#000", textTransform: "none", marginLeft: 1 }}>
    Person
</Button> */}
</Grid>

{/* Dashboard and Actions */}
<Grid item sx={{ marginLeft: "auto" }}>
<Button variant="contained" sx={{ background: "#ff41b4", color: "#fff", textTransform: "none" }}
onClick={()=>{navigate('/dashboard')}}
>
    Admin Dashboard
</Button>
{userType !== "SUB COMPANY" && (
<Button variant="outlined" sx={{ marginLeft: 1, textTransform: "none" }}
onClick={()=>{navigate('/triplist')}}
>
    Trip List
</Button>
)}
</Grid>

{/* bell icon */}

<Grid item>
{userType !== "SUB COMPANY" && (
<ChatApp/>
)}
</Grid>

{/* User Profile */}
<Grid item>
<Avatar src={profiledetails} alt="User" />
</Grid>
</Grid>  
      </>
    );
  };
  
  export default Dispatcherhead;